import { useEffect, useState } from "react";
import TextInput from "../../../components/TextInput";
import PrimaryButton from "../../../components/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { setUserData } from "../../../redux/rootSlice";
import ApiService from "../../../api/ApiServices";
import { stateOptions } from "../../../utils/commonArray";
import moment from "moment";
import { AppPaths } from "../../../utils/AppPaths";
import AlertModal from "../../../components/AlertModal";

const EditLocation = () => {
  const dispatch = useAppDispatch();
  const [cityValue, setCityValue] = useState("");
  const [stateValue, setStateValue] = useState();
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertTitle, setAlertTitle] = useState<string>("Oops!");
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [shouldNavigateProfile, setShouldNavigateProfile] = useState<boolean>(false);
  const navigate = useNavigate();
  const userData = useAppSelector<any>(state => state.root.userData);
  const city = userData?.questions['Where are you from?'].city 
  const state = userData?.questions['Where are you from?'].state

  const openAlert = (title: string, message: string) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setShowAlert(true);
  };

  const handleCityInputChange = (e: any) => {
    setCityValue(e.target.value);
  };

  const handleStateInputChange = (value: any) => {
    setStateValue(value);
  };

  const onContinue = async () => {
    try {
      const response = await ApiService.updateUserDetails({
        city: cityValue,
        state: stateValue,
        updatedAt: moment().format('YYYY-MM-DD'),
      });
      if (response?.status) {
        setShouldNavigateProfile(true);
        openAlert("Changes Saved", response?.message || "Location updated successfully.");
        // dispatch(setUserData(response.data.user?.questions['Where are you from?'].city));
        // dispatch(setUserData(response.data.user?.questions['Where are you from?'].state));
      }
    } catch (error) {
      setShouldNavigateProfile(false);
      openAlert("Error", "Error while updating location.");
      console.error("Error while updating username:", error);
    }
  }

  useEffect(() => {
    if (city) {
      setCityValue(city)
    }
  }, [city])

  useEffect(() => {
    if (state) {
      setStateValue(state)
    }
  }, [state])
  return (
    <div className="flex flex-1 flex-col relative pb-20 mx-1 pt-3 mb-5">
      <div className="flex flex-row mx-3 items-center">
        <div>
          <img
            onClick={() => {
              navigate(-1);
            }}
            alt=""
            className="home-frag-pic-backbtn mr-2"
            src={require("../../../assets/arrow-left.png")}
          />
        </div>
        <div className="btn-onb2-text flex flex-1 items-center justify-center">
          Edit Location
        </div>
      </div>
      <div className="flex flex-col flex-1 mx-3">
        <span className="">
          <div className="input-text-14-bold mt-4">City</div>
          <TextInput
            placeholder=""
            value={cityValue}
            onChange={handleCityInputChange}
            containerStyles="px-3 py-3 flex flex-1"
          />
        </span>
        <span className="">
          <div className="input-text-14-bold mt-4">State</div>
          {/* <TextInput
            placeholder=""
            value={stateValue}
            onChange={handleStateInputChange}
            containerStyles="px-3 py-3 flex flex-1"
          /> */}
          <div className="TextInputDropDown   flex flex-1 flex-row items-cente px-3 py-3 w-full">
            <select
              value={stateValue || ""}
              className={`flex flex-1  decoration-none outline-none bg-white selectOptions ${stateValue && "font-black"
                }`}
              // onChange={(e) => {
              //   const item = options?.find(
              //     (option) => option.value === e.target.value
              //   );
              //   if (item) {
              //     handleStateInputChange(item.value);
              //   }
              // }}
              onChange={(e) => handleStateInputChange(e.target.value)}
            >
              <option value="" disabled hidden>
                Select your state
              </option>
              {stateOptions?.map((option) => (
                <option className="flex flex-1 outline-none">
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </span>
      </div>
      <PrimaryButton
        onClick={onContinue}
        text="SAVE"
        containerStyles="py-2 mx-5"
        textStyle="inter-16-bold"
      />
      <AlertModal
        visible={showAlert}
        title={alertTitle}
        message={alertMessage}
        onConfirm={() => {
          setShowAlert(false);
          if (shouldNavigateProfile) {
            setShouldNavigateProfile(false);
            navigate(AppPaths.PROFILE);
          }
        }}
      />
    </div>
  );
};

export default EditLocation;
